import TYPE from "../../constants/type";
import { apiCall } from "../../utils/api";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getAllAchievement = () => async (dispatch) => {
  const api = API_URLS.ACHIEVEMENT.getAllAchievement();
  dispatch({
    type: TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_LOADING,
    meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_FAILURE,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      }),
    );
  }
};

export const getFilteredAchievement = (page, pageSize, payload) => async (dispatch) => {
  const api = API_URLS.ACHIEVEMENT.getFilteredAchievement(page, pageSize);
  dispatch({
    type: TYPE.ACHIEVEMENT.GET_FILTERED_ACHIEVEMENT_LOADING,
    meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.ACHIEVEMENT.GET_FILTERED_ACHIEVEMENT_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.ACHIEVEMENT.GET_FILTERED_ACHIEVEMENT_FAILURE,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      }),
    );
  }
};

export const getAllAchievementByProfileId = (id) => async (dispatch) => {
  const api = API_URLS.ACHIEVEMENT.getAllAchievementByProfileId(id);
  dispatch({
    type: TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_BY_PROFILE_ID_LOADING,
    meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_BY_PROFILE_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.ACHIEVEMENT.GET_ALL_ACHIEVEMENT_BY_PROFILE_ID_FAILURE,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Lấy dữ liệu thất bại!",
      }),
    );
  }
};

export const insertAchievement = (profileId, payload) => async (dispatch) => {
  const api = API_URLS.ACHIEVEMENT.insertAchievement();
  dispatch({
    type: TYPE.ACHIEVEMENT.INSERT_ACHIEVEMENT_LOADING,
    meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.ACHIEVEMENT.INSERT_ACHIEVEMENT_SUCCESS,
      id: profileId,
      payload: response.data.data,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Thêm dữ liệu thành công!",
      }),
    );
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.ACHIEVEMENT.INSERT_ACHIEVEMENT_FAILURE,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Thêm dữ liệu thất bại!",
      }),
    );
    return { success: false, data: null };
  }
};

export const updateAchievement = (id, payload) => async (dispatch) => {
  const api = API_URLS.ACHIEVEMENT.updateAchievement(id);
  dispatch({
    type: TYPE.ACHIEVEMENT.UPDATE_ACHIEVEMENT_LOADING,
    meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.ACHIEVEMENT.UPDATE_ACHIEVEMENT_SUCCESS,
      id,
      payload: response.data.data,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật dữ liệu thành công!",
      }),
    );
    return { success: true };
  } else {
    dispatch({
      type: TYPE.ACHIEVEMENT.UPDATE_ACHIEVEMENT_FAILURE,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_FAILURE] },
    });

    // Check for specific error codes
    const errorCode = response?.data?.error || response?.data?.message;
    if (errorCode && (errorCode.includes("ERR_HEMIS_DUPLICATE") || errorCode.includes("duplicate hemisCode"))) {
      return { success: false, error: "ERR_HEMIS_DUPLICATE", message: response?.data?.message };
    }

    dispatch(
      notification({
        type: "error",
        message: "Cập nhật dữ liệu thất bại!",
      }),
    );
    return { success: false };
  }
};

export const deleteAchievement = (id) => async (dispatch) => {
  const api = API_URLS.ACHIEVEMENT.deleteAchievement(id);
  dispatch({
    type: TYPE.ACHIEVEMENT.DELETE_ACHIEVEMENT_LOADING,
    meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.ACHIEVEMENT.DELETE_ACHIEVEMENT_SUCCESS,
      id,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xoá dữ liệu thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.ACHIEVEMENT.DELETE_ACHIEVEMENT_FAILURE,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xoá dữ liệu thất bại!",
      }),
    );
    return false;
  }
};

export const acceptAchievement = (id, accept) => async (dispatch) => {
  const api = API_URLS.ACHIEVEMENT.acceptAchievement(id, accept);
  dispatch({
    type: TYPE.ACHIEVEMENT.ACCEPT_ACHIEVEMENT_LOADING,
    meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.ACHIEVEMENT.ACCEPT_ACHIEVEMENT_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xác nhận thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.ACHIEVEMENT.ACCEPT_ACHIEVEMENT_FAILURE,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xác nhận thất bại!",
      }),
    );
    return false;
  }
};

export const checkDuplicateAchievement = (payload) => async (dispatch) => {
  const api = API_URLS.ACHIEVEMENT.checkDuplicateAchievement();
  dispatch({
    type: TYPE.ACHIEVEMENT.CHECK_DUPLICATE_ACHIEVEMENT_LOADING,
    meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200) {
    dispatch({
      type: TYPE.ACHIEVEMENT.CHECK_DUPLICATE_ACHIEVEMENT_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_SUCCESS] },
    });
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.ACHIEVEMENT.CHECK_DUPLICATE_ACHIEVEMENT_FAILURE,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_FAILURE] },
    });
    notification({
      type: "error",
      message: "Kiểm tra trùng lặp thất bại!",
    });
    return { success: false, data: [], error: true };
  }
};

export const exportAchievement = (payload) => async (dispatch) => {
  const api = API_URLS.ACHIEVEMENT.exportDynamic();
  dispatch({
    type: TYPE.ACHIEVEMENT.EXPORT_ACHIEVEMENT_LOADING,
    meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.ACHIEVEMENT.EXPORT_ACHIEVEMENT_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_SUCCESS] },
    });

    // Download the file
    const downloadApi = API_URLS.ACHIEVEMENT.downloadExportFile(response.data.data.filePath);
    const downloadUrl = `${process.env.REACT_APP_DOMAIN}${downloadApi.endPoint}`;

    // Create a temporary link and trigger download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = response.data.data.fileName || "achievement_export.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    dispatch(
      notification({
        type: "success",
        message: "Xuất dữ liệu thành công!",
      }),
    );
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.ACHIEVEMENT.EXPORT_ACHIEVEMENT_FAILURE,
      meta: { prefix: [PREFIX.ACHIEVEMENT, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: error?.message || "Xuất dữ liệu thất bại!",
      }),
    );
    return { success: false };
  }
};

